import RudderStackScript from "./RuudderStackScript";

export default RudderStackScript;
